import React, { useEffect, useState } from "react";
import "../css/Main.css"
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";
import { Snackbar, Alert, Drawer, Avatar } from "@mui/material";
import miAxios from "../api/axios";
import Wait from "../components/Wait";
import iconHome from "../assets/menu-home2.png";
import iconConfig from "../assets/menu-configuracion.png";
import iconConsulta from "../assets/menu-consultas.png";
import iconProcesos from "../assets/menu-procesos.png";
import iconReportes from "../assets/menu-reportes.png"
import CambioClave from "../components/CambioClave";
import Datos from "./Datos";

export default function Main(props) {
    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")
    const [openMenu, setOpenMenu] = useState(true)
    const [opcionSeleccionada, setOpcionSeleccionada] = useState(0)
    const [openCambiarClave, setCambiarClave] = useState(false)
    const [openDatos, setOpenDatos] = useState(false)
    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    const [grupos, setGrupos] = useState(user.menuGrupos);

    /* const [menus, setMenus] = useState([
        { id: 0, texto: "Dashboard", grupo: 0, opcion: "/dashboard" },
        { id: 1, texto: "Videos promoción", grupo: 1, opcion: "/videos" },
        { id: 2, texto: "Nuestras ofertas", grupo: 1, opcion: "" },
        { id: 5, texto: "Nuestro catálogo", grupo: 1, opcion: "/catalogo" },
        { id: 6, texto: "Reacciones", grupo: 1, opcion: "/reacciones" },
        { id: 3, texto: "Despachos", grupo: 3, opcion: "/despachos" },
        { id: 7, texto: "Despachos", grupo: 4, opcion: "/reportes/proveedores_despachos" },
        { id: 9, texto: "Histórico Ordenes", grupo: 2, opcion: "/ordenes" },
        { id: 8, texto: "Histórico Despachos", grupo: 2, opcion: "/transacciones" },
        { id: 14, texto: "Actualizar mis datos", grupo: 5, opcion: "/datos", nivel: 1 },
        { id: 16, texto: "Cambiar mi contraseña", grupo: 5, opcion: "/", nivel: 2 },
        { id: 15, texto: "Cerrar sesión", grupo: 5, opcion: "/", nivel: 1 },
    ]) */

    const menus = user.menu;

    const navigate = useNavigate()


    const toggleDrawer = (newOpen) => () => {
        setOpenMenu(newOpen);
    };

    const handleSeleccionGrupo = (id) => {
        let newR = grupos.map((grupo) => {
            if (grupo.id == id) {
                return {
                    ...grupo,
                    seleccion: !grupo.seleccion
                }
            } else {
                return {
                    ...grupo,
                    seleccion: false
                }
            }
        })
        setGrupos(newR)

    }

    const handleClick = (id) => {
        const opcion_seleccionada = menus.filter((row) => row.id == id)[0].opcion
        const grupo_seleccionado = menus.filter((row) => row.id == id)[0].grupo

        if (id == 14) {
            setOpenDatos(true)
            return;
        }

        if (id == 16) {
            setCambiarClave(true)
            return;
        }

        if (id == 15) {
            console.log("sali por aqui...")
            user?.handleLogout();
            //navigate("/login")
            return;
        }

        setOpenMenu(false)
        if (opcion_seleccionada.length == 0) { return; }

        if (grupo_seleccionado == 4) {
            window.open(opcion_seleccionada, "_blank")
            return;
        }

        navigate(opcion_seleccionada)
    }

    const handleOpenMenu = () => {
        setOpenMenu(true)
    }

    return (
        <div className="Main-cuerpo">
            <Wait procesando={procesando} />
            {
                openCambiarClave && (
                    <CambioClave
                        open={openCambiarClave}
                        cerrar={() => { setCambiarClave(false) }}
                    />
                )
            }
            {
                openDatos && (
                    <Datos
                        open={openDatos}
                        cerrar={() => { setOpenDatos(false) }}
                    />
                )
            }
            <Snackbar
                open={mensaje.length == 0 ? false : true}
                sx={{ zIndex: 500000 }}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={() => { setMensaje("") }}
            >
                <Alert severity="error" onClose={() => { setMensaje("") }} variant="filled">{mensaje}</Alert>
            </Snackbar>
            <Drawer open={openMenu} onClose={toggleDrawer(false)}>
                <div className="Main-menu">
                    <div className="Main-menu-header">
                        <div className="Main-menu-header-img">
                            <img src={"./logo.png"} />
                        </div>
                        <div className="Main-menu-header-titulo">
                            COOEPROUASD - Proveedores
                        </div>
                    </div>
                    <div className="Main-menu-body">
                        <div className={"Main-menu-grupos "} >
                            <div className="Main-menu-grupos-rows" onClick={() => { handleClick(0) }}>
                                <div className="Main-menu-grupos-img"><img src={iconHome} /></div>
                                <div className="Main-menu-grupos-titulo">Inicio</div>
                                <div className="Main-menu-grupos-icono"></div>
                            </div>
                        </div>
                        {
                            grupos.map((grupo) => {
                                return (
                                    <div key={grupo.id} className={"Main-menu-grupos " + (grupo.seleccion ? " selected" : "")} >
                                        <div className="Main-menu-grupos-rows" onClick={() => { handleSeleccionGrupo(grupo.id) }}>
                                            <div className="Main-menu-grupos-img"><img src={(grupo.id == 1 ? iconConfig : (grupo.id == 2 ? iconConsulta : (grupo.id == 3 ? iconProcesos : (grupo.id == 4 ? iconReportes : iconConfig))))} /></div>
                                            <div className="Main-menu-grupos-titulo">{grupo.texto}</div>
                                            <div className="Main-menu-grupos-icono">{">"}</div>
                                        </div>
                                        <div className="Main-menu-grupos-hijos">
                                            {
                                                menus.filter((elem) => elem.grupo == grupo.id).map((row) => {
                                                    return (
                                                        <div key={row.id} className="Main-menu-rows" onClick={() => { handleClick(row.id) }}>{row.texto}</div>)
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>
            </Drawer>
            <div className="Main-header">
                <div className="Main-header-menu" onClick={() => { handleOpenMenu() }}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className="Main-header-titulo">
                    COOEPROUASD - Proveedores
                </div>
                <div className="Main-header-foto">
                    <Avatar alt="Foto Socio" />
                </div>
            </div>
            <div className="Main-body">

                <Outlet />

            </div>
            <div className="Main-footer">
                {user?.nombre + " / " + user?.usuarioNombre}
            </div>
        </div>
    )
}